import { keycloakInstance } from './keycloak';

export const getAuthToken = (): string => keycloakInstance?.token || '';

export const getAuthHeader = (): string => `Bearer ${getAuthToken()}`;
